/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable no-underscore-dangle */
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LoaderService {

    public loaders: Subject<any[]> = new Subject<any[]>();
    private _loaders: string[] = [];

    constructor() {}

    addLoader(observable) {
        if (this._loaders.indexOf(observable) === -1) {
            this._loaders.push(observable);
            this.loaders.next(this._loaders);
        }
    }

    removeLoader(observable) {
        this._loaders = this._loaders.filter(loader => loader !== observable);
        this.loaders.next(this._loaders);
    }

}
